import { useMemo } from 'react';
import { useAppSelector } from 'store/hook';

interface Props {
  selectedAssets: string[];
}

const useComponentCostBreakdown = ({ selectedAssets }: Props) => {
  const components = useAppSelector(
    (state) => state.squaresDashboardReducer.dashboard.components
  );

  const pieChartData = useMemo(() => {
    if (!components) {
      return [];
    }

    const pieChartMap = new Map<string, { total_cost: number }>();
    const selectedAssetsSet = new Set(selectedAssets);
    const entries = Object.entries(components ?? {});

    for (const entry of entries) {
      const [component, values] = entry;
      const { assets } = values;
      pieChartMap?.set(component, {
        total_cost: 0,
      });
      let { total_cost: totalCost } = pieChartMap.get(component) ?? {
        total_cost: 0,
      };
      for (const assetData of assets) {
        const { asset, total_asset_cost: totalAssetCost } = assetData;
        if (selectedAssetsSet.has(asset)) {
          totalCost += totalAssetCost;
        }
      }
      pieChartMap.set(component, {
        total_cost: totalCost,
      });
    }
    const pieChartData: Array<{
      asset: string;
      name: string;
      total_asset_cost: number;
    }> = [];
    pieChartMap.forEach((value, key) => {
      pieChartData.push({
        asset: key,
        name: key,
        total_asset_cost: value.total_cost,
      });
    });

    const sortedData = pieChartData?.sort(
      (a, b) => b.total_asset_cost - a.total_asset_cost
    );

    return sortedData;
  }, [components, selectedAssets]);

  return {
    pieChartData,
  };
};

export default useComponentCostBreakdown;
